import React from 'react'

const Settings = () => {
  return (
    <div>
      this is settings page
    </div>
  )
}

export default Settings;
